import CreateInvestStrategyFormNew from './CreateInvestStrategyFormNew';

export default CreateInvestStrategyFormNew;
